const initialState = {
  isBrandLoading: false,
  selectedBusiness: null,
  currentSelectedBrand: null,
  // Brand List
  brandList: [],
  currentSelectedBrand: null,
  // Location List
  locationList: [],
  currentSelectedLocation: null,
  // Search List
  filteredBrandList: [],
  filteredLocationList: [],
  searchLoading: false,
  // Pagination
  pagination: {
    totalPages: 0,
    totalCount: 0,
    limit: 10,
    page: 1,
    hasNextPage: null,
    hasPreviousPage: null,
    nextPage: 1,
  },
  paginationSearchBrand: {
    totalPages: 0,
    totalCount: 0,
    limit: 10,
    page: 1,
    hasNextPage: null,
    hasPreviousPage: null,
    nextPage: 1,
  },
  fetchMoreDataLoading: false,
  showOnlyActiveBusinesses:
    localStorage.getItem('showActiveBusiness') === null
      ? true
      : Boolean(Number(localStorage.getItem('showActiveBusiness'))),
};

const mev3 = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BRAND_LIST':
      return { ...state, brandList: action.payload };
    case 'APPEND_BRAND_LIST':
      return {
        ...state,
        brandList: [...state.brandList, ...action.payload],
      };
    case 'SET_FETCH_MORE_DATA_LOADING':
      return { ...state, fetchMoreDataLoading: action.payload };
    case 'SET_CURRENT_BRAND_MEV3':
      const currentLocationStorage = JSON.parse(
        localStorage.getItem('selectedLocation')
      );
      const currentLocation = action.payload?.locations?.find(
        (location) =>
          location.businessId === currentLocationStorage?.value?.businessId
      );

      // If currentLocation is found, move it to the top of the list
      let orderedLocationList = action.payload?.locations;
      if (currentLocation) {
        const otherLocations = action.payload?.locations?.filter(
          (location) => location.businessId !== currentLocation.businessId
        );
        orderedLocationList = [currentLocation, ...otherLocations];
      }

      return {
        ...state,
        currentSelectedBrand: action.payload,
        locationList: orderedLocationList,
        currentSelectedLocation:
          currentLocation ?? action.payload?.locations[0],
      };
    case 'SET_CURRENT_LOCATION':
      return {
        ...state,
        currentSelectedLocation: action.payload,
      };
    case 'SET_PAGINATION_CONFIG':
      return { ...state, pagination: action.payload };
    case 'SET_SEARCH_LOCATION':
      return { ...state, filteredLocationList: action.payload };
    case 'SET_SEARCH_BRAND_LIST':
      return {
        ...state,
        filteredBrandList: action.payload,
      };
    case 'SET_PAGINATION_CONFIG_SEARCH_BRAND':
      return { ...state, paginationSearchBrand: action.payload };
    case 'SET_SEARCH_LOADING':
      return { ...state, searchLoading: action.payload };
    case 'APPEND_SEARCH_BRAND_LIST':
      return {
        ...state,
        filteredBrandList: [...state.filteredBrandList, ...action.payload],
      };
    case 'RESET_SEARCH_BRAND_LIST':
      return {
        ...state,
        filteredBrandList: [],
        filteredLocationList: [],
        paginationSearchBrand: {
          totalPages: 0,
          totalCount: 0,
          limit: 10,
          page: 1,
          hasNextPage: null,
          hasPreviousPage: null,
          nextPage: 1,
        },
      };
    case 'SET_SHOW_ONLY_ACTIVE_BUSINESSES':
      return {
        ...state,
        showOnlyActiveBusinesses: action.payload,
        pagination: {
          totalPages: 0,
          totalCount: 0,
          limit: 10,
          page: 1,
          hasNextPage: null,
          hasPreviousPage: null,
          nextPage: 1,
        },
        paginationSearchBrand: {
          totalPages: 0,
          totalCount: 0,
          limit: 10,
          page: 1,
          hasNextPage: null,
          hasPreviousPage: null,
          nextPage: 1,
        },
        brandList: [],
        locationList: [],
        filteredBrandList: [],
        filteredLocationList: [],
      };
    default:
      return state;
  }
};

export default mev3;
